import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../resources/css/carousel.css';
import Separator from './shared/Separator';
import { Link } from "react-router-dom";
import Slider from "react-slick";

export default function Carousel({ data }) {

    const { title, secondTitle, background, slides, style, columns } = data;

    let styleCss = '';
    switch (style) {
        case 'pink': {
            styleCss = 'carousel-background-pink';
            break;
        }
        case 'blue': {
            styleCss = 'carousel-background-blue';
            break;
        }
        default: {
            styleCss = 'carousel-background-blue';
            break;
        }
    }

    const calculatedWidth = columns === 3 ? '23rem' : '46rem';

    const renderedSlides = (slides || []).map((slide) => {
        const content = <div className="carousel-slide" style={{ width: calculatedWidth }}>

            {slide.title && <div className="carousel-slide-title title-h2">{slide.title}</div>}

            <p>{slide.secondTitle}</p>

            {slide.rater && <div className="title-h4">{slide.rater}</div>}

            <div>
                <img src={slide.photo} alt={slide.title} ></img>
            </div>

        </div>;

        return slide.url ? <Link key={slide.id} to={slide.url}>{content}</Link> : <div className="carousel-slide-top" key={slide.id}>{content}</div>;
    });

    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: columns,
        slidesToScroll: 1,
        autoplaySpeed: 5000,
        autoplay: true,
        arrows: true
    };

    const styleBack = { backgroundImage: `url(${background})` };

    return (
        <div className="carousel" style={styleBack}>
            <div className={`carousel-background ${styleCss}`}></div>
            <div className="carousel-content">

                {title && <div className="title-h1">{title}</div>}

                <Separator className="color-white"></Separator>

                {secondTitle && <div className="carousel-second-title">{secondTitle}</div>}

                <div className="carousel-slider">

                    <Slider {...settings}>
                        {renderedSlides}
                    </Slider>

                </div>
            </div>

        </div>
    );
}